import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import HeaderContactOptionsMenu from 'components/App/Header/HeaderContactOptions/HeaderContactOptionsMenu'
import NavigationHeaderPhoneMenu from 'components/App/Header/HeaderMain/NavigationHeader/NavigationHeaderPhoneMenu'
import TextButton from 'LuxKit/Button/TextButton'
import IconButton from 'LuxKit/Button/IconButton'
import CheckoutSaveButtonGuard from 'tripPlanner/components/EntryPoints/CheckoutSaveButtonGuard'
import CheckoutSaveButton from 'tripPlanner/components/EntryPoints/CheckoutSaveButton'
import CheckoutStepperProgress from './CheckoutStepperProgress'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import LineArrowLeftIcon from 'LuxKit/Icons/line/LineArrowLeftIcon'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import CheckoutDevModeToggle from 'checkout/Components/Shared/CheckoutDevModeToggle'
import ExperimentPanelButton from '../ExperimentPanelButton'
import { StepClickHandler } from 'LuxKit/Steppers/StepperProgressStep'

const HeaderContainer = styled.div`
  display: grid;
  grid-template: "start-actions middle end-actions" auto / auto minmax(0, 1fr) auto;
  align-items: center;
  padding-block: ${rem(4)};
`

const StartActions = styled(Group)`
  grid-area: start-actions;
`

const EndActions = styled(Group)`
  grid-area: end-actions;
`

const Middle = styled(Group)`
  grid-area: middle;
`

interface Props {
  onBack: () => void
  onStepClick?: StepClickHandler
}

function StepsHeaderCheckout({ onBack, onStepClick }: Props) {
  const intl = useIntl()
  const handlerBack = useCallback(() => {
    onBack()
  }, [onBack])

  return <HeaderContainer>
    <StartActions direction="horizontal" gap={4} verticalAlign="center">
      <CSSBreakpoint min="largeDesktop">
        <TextButton
          horizontalOutdent="start"
          kind="tertiary"
          size="large"
          startIcon={<LineArrowLeftIcon />}
          onClick={handlerBack}
        >
          {intl.formatMessage({
            id: 'WCdYYG15FJ',
            defaultMessage: 'Back',
            description: 'Back button text in checkout stepper header',
          })}
        </TextButton>
      </CSSBreakpoint>
      <CSSBreakpoint max="desktop">
        <IconButton
          horizontalOutdent="start"
          kind="tertiary"
          size="large"
          onClick={handlerBack}
        >
          <LineArrowLeftIcon />
        </IconButton>
      </CSSBreakpoint>
      <CheckoutDevModeToggle />
    </StartActions>
    <Middle direction="horizontal" horizontalAlign="center">
      <CheckoutStepperProgress onStepClick={onStepClick} />
    </Middle>
    <EndActions direction="horizontal" gap={4}>
      <CSSBreakpoint min="largeDesktop">
        <NavigationHeaderPhoneMenu />
      </CSSBreakpoint>
      <CSSBreakpoint max="desktop">
        <HeaderContactOptionsMenu size="large" />
      </CSSBreakpoint>
      <CheckoutSaveButtonGuard>
        <CheckoutSaveButton />
      </CheckoutSaveButtonGuard>
      <ExperimentPanelButton />
    </EndActions>
  </HeaderContainer>
}

export default StepsHeaderCheckout
